"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GA4EventLabel = void 0;
var GA4EventLabel;
(function (GA4EventLabel) {
    GA4EventLabel["Profile"] = "Customer account profile";
    GA4EventLabel["Settings"] = "Customer account settings";
    GA4EventLabel["Orders"] = "Customer account orders";
    GA4EventLabel["Wishlist"] = "Customer account wishlist";
    GA4EventLabel["Redemption"] = "Customer account redemption";
    GA4EventLabel["Voucher_validity"] = "Customer account voucher validity";
    GA4EventLabel["TileView"] = "tile view";
    GA4EventLabel["ListView"] = "list view";
    GA4EventLabel["MapView"] = "map view";
    GA4EventLabel["More"] = "More";
    GA4EventLabel["Support"] = "Support";
    GA4EventLabel["StartBrowsing"] = "Start Browsing";
    GA4EventLabel["LogIn"] = "Log In";
})(GA4EventLabel || (exports.GA4EventLabel = GA4EventLabel = {}));
//# sourceMappingURL=GA4EventLabel.js.map